import { render, staticRenderFns } from "./RegionIndex.vue?vue&type=template&id=e412d3f0&"
import script from "./RegionIndex.vue?vue&type=script&lang=js&"
export * from "./RegionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports